import type { DefaultOperatorName, Field } from 'react-querybuilder';
import type { ConditionFieldName } from './const';

export const SHARED_ENUM_FIELD_CONFIG: Partial<Field<ConditionFieldName, DefaultOperatorName>> = {
  valueEditorType(operator: string): 'select' | 'multiselect' {
    return operator === 'in' ? 'multiselect' : 'select';
  },
  defaultOperator: 'in' satisfies DefaultOperatorName,
  operators: [
    { name: '=', label: 'is' },
    { name: '!=', label: 'is not' },
    { name: 'in', label: 'in' },
    { name: 'notIn', label: 'not in' },
  ],
  defaultValue: null,
};

export const SHARED_TEXT_FIELD_CONFIG: Partial<Field<ConditionFieldName, DefaultOperatorName>> = {
  inputType: 'text',
  operators: [
    { name: '=', label: 'is' },
    { name: '!=', label: 'is not' },
    { name: 'contains', label: 'contains' },
    { name: 'beginsWith', label: 'begins with' },
    { name: 'endsWith', label: 'ends with' },
    { name: 'doesNotContain', label: 'does not contain' },
    { name: 'doesNotBeginWith', label: 'does not begin with' },
    { name: 'doesNotEndWith', label: 'does not end with' },
  ],
};

export const SHARED_NUMBER_FIELD_CONFIG: Partial<Field<ConditionFieldName, DefaultOperatorName>> = {
  inputType: 'number',
  operators: [
    { name: '=', label: 'equals' },
    { name: '<', label: 'less than' },
    { name: '<=', label: 'less than or equal to' },
    { name: '>', label: 'greater than' },
    { name: '>=', label: 'greater than or equal to' },
    { name: 'between', label: 'between' },
  ],
};

type EnumKeys<T> = {
  [K in keyof T]: T[K] extends string ? K : never;
}[keyof T];

type EnumLike<T> = {
  [K in EnumKeys<T>]: T[K];
};

/**
 * Converts an enum or object to options format for select/multiselect fields
 * Sorts the options alphabetically by value
 */
export const enumToOptions = <T extends EnumLike<T>>(enumType: T): { name: string; label: string }[] =>
  Object.values(enumType)
    .sort((a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase()))
    .map((value: string) => ({ name: value, label: value }));
